import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { updateAutomaticPaymentRemindersSettings } from '../query-api'

export const useUpdateAutomaticPaymentRemindersSettings = () => {
  const queryClient = useQueryClient()

  const {
    mutate: update,
    isLoading: isProcessing,
    ...rest
  } = useMutation(updateAutomaticPaymentRemindersSettings, {
    onSuccess: (response) => {
      queryClient.setQueryData([QueryKeys.PaymentRemindersSettings], response)
    },
  })

  return { update, isProcessing, ...rest }
}
